import { ScoutFeature } from "../../../Enums/ScoutFeature";
import { App } from "../Enums/App";
import { LinkType } from "../Enums/LinkType";
import { IHoverData } from "./IHoverData";
import { INoAccessData } from "./INoAccessData";

export interface ILinkObject {
    type: LinkType;/* Type of link(external, internal, or SCOUT) */
    requiredFeatures: ScoutFeature[];/* string to match off from the GET user data call > response data > features > name */
    title: string;/* Text shown below icon */
    shortTitle: string;
    link: string;/* Link to */
    externalLink: string;
    icon: string;/* Icon image link */
    quickLinksIcon: string;
    hoveredQuickLinksIcon: string;
    hoveredIcon: string;/* Hovered icon image link */
    hoverData: IHoverData;/* Configs for right panel image and text */
    noAccessData: INoAccessData;/* Configs for popup modal */
    app: App;
    exists?: boolean;
}